import { RepositoryFactory } from '@/repositories/RepositoryFactory';

const usuariosRepository = RepositoryFactory.get('usuario');

const state = {
  usuario: null,
  unidade: null,
  unidadePai: null,
  comissao: false,
  chefia: false,
  substituicaoChefia: false,
  subChefia: false,
  subUnidades: [],
  subUnidadesHierarquia: [],
};

const actions = {
  load({ commit }) {
    return new Promise((resolve) => {
      usuariosRepository.getDados().then((response) => {
        const dados = response.data;
        if (dados) {
          commit('SET_USUARIO', dados.USUARIO);
          commit('tutorial/SET_DADOS', dados.TUTORIAL, { root: true });
          commit('SET_UNIDADE', dados.UNIDADE);
          commit('unidade/SET_UNIDADES', dados.UNIDADES, { root: true });
          commit('SET_UNIDADE_PAI', dados.UNIDADE_PAI);
          commit('SET_COMISSAO', dados.COMISSAO);
          commit('SET_CHEFIA', dados.CHEFIA);
          commit('SET_SUBSTITUICAO_CHEFIA', dados.SUBSTITUICAO_CHEFIA);
          commit('SET_SUB_CHEFIA', dados.SUB_CHEFIA);
          commit('SET_SUB_UNIDADES', dados.SUB_UNIDADES);
          commit('SET_SUB_UNIDADES_HIERARQUIA', dados.SUB_UNIDADES_HIERARQUIA);

          commit('comportamento/SET_COMPORTAMENTOS_CONSOLIDADOS', dados.COMPORTAMENTOS_CONSOLIDADOS, { root: true });
          commit('competencia/SET_COMPETENCIAS_COMPORTAMENTAIS', dados.COMPETENCIAS_COMPORTAMENTAIS, { root: true });
          commit('competencia/SET_COMPETENCIAS_TECNICAS', dados.COMPETENCIAS_TECNICAS, { root: true });

          if (dados.MAPEAMENTOS.length > 0) {
            commit('mapeamento/SET_MAPEAMENTOS', dados.MAPEAMENTOS, { root: true });
            commit('mapeamento/SET_USUARIOS_MAPEAMENTOS', dados.USUARIOS_MAPEAMENTOS, { root: true });
            commit('mapeamento/SET_MAPEAMENTO', dados.MAPEAMENTOS[0], { root: true });
          }

          if (dados.COMISSAO) {
            commit('mapeamento/SET_MAPEAMENTOS_COMISSAO', dados.MAPEAMENTOS_COMISSAO, { root: true });
            if (dados.MAPEAMENTOS_COMISSAO.length > 0) {
              commit('mapeamento/SET_MAPEAMENTO_COMISSAO', dados.MAPEAMENTOS_COMISSAO[0], { root: true });
            }

            commit('diagnostico/SET_DIAGNOSTICOS_COMISSAO', dados.DIAGNOSTICOS_COMISSAO, { root: true });
            if (dados.DIAGNOSTICOS_COMISSAO.length > 0) {
              commit('diagnostico/SET_DIAGNOSTICO_COMISSAO', dados.DIAGNOSTICOS_COMISSAO[0], { root: true });
            }
          }

          commit('diagnostico/SET_DISPENSAS', dados.DISPENSAS_DIAGNOSTICO, { root: true });
          commit('diagnostico/SET_DISPENSAS_CHEFIA', dados.DISPENSAS_DIAGNOSTICO_CHEFIA, { root: true });
          commit('diagnostico/SET_DISPENSAS_EQUIPE', dados.DISPENSAS_DIAGNOSTICO_EQUIPE, { root: true });

          if (dados.DIAGNOSTICOS.length > 0) {
            const diagnostico = { ...dados.DIAGNOSTICOS[0] };

            commit('diagnostico/SET_DIAGNOSTICOS', dados.DIAGNOSTICOS, { root: true });
            commit('diagnostico/SET_DIAGNOSTICO', diagnostico, { root: true });
            if (dados.COMPORTAMENTOS_CONSOLIDADOS && diagnostico.mapeamento) {
              const comportamentos = dados.COMPORTAMENTOS_CONSOLIDADOS.filter(
                (c) => c.mapeamento.id === diagnostico.mapeamento.id,
              );
              commit('diagnostico/SET_COMPORTAMENTOS', comportamentos, { root: true });
            }
          }

          commit('perfil/SET_DEFICIENCIAS', dados.DEFICIENCIAS, { root: true });
          commit('perfil/SET_CURSOS', dados.CURSOS, { root: true });
          commit('perfil/SET_AREAS_PERFIL', dados.AREAS_PERFIL, { root: true });
          commit('perfil/SET_IDIOMAS', dados.IDIOMAS, { root: true });
          commit('perfil/SET_PREFERENCIAS', dados.PREFERENCIAS, { root: true });
          commit('perfil/SET_ITENS_PREFERENCIA', dados.ITENS_PREFERENCIA, { root: true });
          commit('perfil/SET_LISTA_SETORES', dados.TIPOS_SETOR, { root: true });
          commit('perfil/SET_LISTA_VINCULOS', dados.TIPOS_VINCULO, { root: true });
          commit('perfil/SET_LISTA_CARGOS', dados.TIPOS_CARGO, { root: true });
          commit('perfil/SET_LISTA_FUNCOES', dados.TIPOS_FUNCAO, { root: true });
          commit('perfil/SET_LISTA_NIVEIS_GRATIFICACOES', dados.TIPOS_NIVEL_GRATIFICACAO, { root: true });
        }
        resolve();
      });
    });
  },
};

const getters = {

};

const mutations = {
  SET_USUARIO: (st, usuario) => {
    st.usuario = usuario;
  },
  SET_UNIDADE: (st, unidade) => {
    st.unidade = unidade;
  },
  SET_UNIDADE_PAI: (st, unidade) => {
    st.unidadePai = unidade;
  },
  SET_COMISSAO: (st, comissao) => {
    st.comissao = comissao;
  },
  SET_CHEFIA: (st, chefia) => {
    st.chefia = chefia;
  },
  SET_SUBSTITUICAO_CHEFIA: (st, substituicaoChefia) => {
    st.substituicaoChefia = substituicaoChefia;
  },
  SET_SUB_CHEFIA: (st, subChefia) => {
    st.subChefia = subChefia;
  },
  SET_SUB_UNIDADES: (st, subUnidades) => {
    st.subUnidades = subUnidades;
  },
  SET_SUB_UNIDADES_HIERARQUIA: (st, subUnidadesHierarquia) => {
    st.subUnidadesHierarquia = subUnidadesHierarquia;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
